// import AuthLayout from "../../components/";
import { Button, Col, Image, Layout, List, Row } from "antd";
import { FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router";
import { ImageUrl } from "../../helpers/Function";
// import router from "next/router";

function Planning() {
  const navigate = useNavigate();

  const data1 = [
    {
      title: "Attach a logo to the portal.",
    },
    {
      title: "Create a referral code for users to self-enroll into a portal.",
    },
  ];

  return (
    <>
      <Layout style={{ minHeight: "100vh", backgroundSize: "cover" }}>
        <section className="bg-white top-bottom-padding two-colum-white">
          <Row justify={"center"}>
            <Col lg={19}>
              <Row justify={"center"} gutter={[32, 32]} className="gutter-0">
                <Col xs={24} sm={24} md={12}>
                  <div className="c-img">
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      src={ImageUrl("c35.png")}
                    />
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div className="">
                    <Image
                      preview={false}
                      alt={"Failed to load image"}
                      src={ImageUrl("miniImg4.png")}
                    />
                    <h4>
                      Planning & Managing for Successful Projects – Project
                      Excellence: A Blueprint for Success
                    </h4>
                    <p className="text-p-16">Duration:2 Hours 30 Minutes</p>
                    <h5 className="c-heading">Who Should Attend</h5>
                    <p className="text-p-16">
                      Custodial Supervisor, Custodial Staff
                    </p>

                    <h5 className="c-heading">Description</h5>

                    <p className="text-p-16">
                      This training program unveils the fundamentals of
                      orchestrating triumphant projects, regardless of their
                      scale. This training is your gateway to mastering the art
                      of defining, organizing, planning, executing, and
                      ultimately closing projects. The complex world of project
                      management is simplified into four distinctive phases,
                      each pivotal to ensuring a seamless journey from project
                      inception to completion. From crafting a written charter
                      that sets the project’s foundation to establishing an
                      actionable framework, transforming sizable tasks into
                      manageable units, devising work schedules, exercising
                      control, and culminating in a methodical closeout phase —
                      this training covers it all.
                    </p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </section>
      </Layout>
    </>
  );
}

export default Planning;
